import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import ExternalLink from 'components/Widgets/ExternalLink';
import Form from './Form';

export default function Popup({ affiliate, closePopup }) {
  return (
    <Modal
      className="student inmodal auto without-overflow"
      show
      onHide={closePopup}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Invite
          {' '}
          {affiliate.attributes.full_name}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h3 className="text-center">
          Do you want to invite
          {' '}
          {affiliate.attributes.full_name}
          ?
        </h3>

        <p className="text-center">
          For Preview Affiliate Invite, click
          {' '}
          <ExternalLink
            href={`/mail_preview/affiliate_invite?id=${affiliate.id}`}
            variant={null}
          >
            here
          </ExternalLink>
          .
        </p>

        <Form closePopup={closePopup} affiliate={affiliate} />
      </Modal.Body>
    </Modal>
  );
}

Popup.propTypes = {
  affiliate: PropTypes.object,
  closePopup: PropTypes.func.isRequired,
};

Popup.defaultProps = {
  affiliate: null,
};
